export default __webpack_public_path__ + "static/media/verification-in-process.422cb619.svg";